import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddQuestionsToQuestionSetModalPage } from './add-questions-to-question-set-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddQuestionsToQuestionSetModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddQuestionsToQuestionSetModalPage]
})
export class AddQuestionsToQuestionSetModalPageModule {}
